import React, { FC } from "react";
import { Helmet } from "react-helmet-async";
import comingSoon from "../../../src/images/coming soon.svg"

export interface PageContactProps {
    className?: string;
}

const PageCarriers: FC<PageContactProps> = ({ className = "" }) => {
    return (
        <div
            className={`nc-PageCarriers overflow-hidden ${className}`}
            data-nc-id="PageCarriers"
        >
            <Helmet>
                <title>Carriers | Vijaydeep</title>
            </Helmet>

            {/* COMING SOON SECTION */}
            <div className="container">
              <div className="flex items-center justify-center h-[60vh]">
                    <img src={comingSoon} alt="coming soon" className="w-[50%]" />
              </div>
            </div>
        </div>
    );
};

export default PageCarriers;
